document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('product-media-modal');
  if (!modal) return;

  const modalOverlay = modal.querySelector('.product-media-modal-overlay');
  const closeButtons = modal.querySelectorAll('[data-close-modal]');
  const carouselContainer = modal.querySelector('.product-media-modal-carousel');
  const viewport = carouselContainer?.querySelector('.embla__viewport');
  const prevButton = carouselContainer?.querySelector('.embla__prev');
  const nextButton = carouselContainer?.querySelector('.embla__next');

  const variantDataScript = document.getElementById('product-variant-data');
  let variantData = null;
  if (variantDataScript) {
    try {
      variantData = JSON.parse(variantDataScript.textContent);
    } catch (e) {
      console.error('Failed to parse variant data:', e);
    }
  }

  let embla = null;
  let currentSlideIndex = 0;
  let visibleSlides = [];

  function getCurrentVariantId() {
    const variantInput = document.querySelector('product-variant-switcher input[name="id"]');
    if (variantInput) {
      return parseInt(variantInput.value);
    }
    return null;
  }

  function getVariantMediaRange(variantId) {
    if (!variantData || !variantId) return null;

    const variant = variantData.variants.find(v => v.id === variantId);
    if (!variant || !variant.media_range) return null;

    return {
      start: variant.media_range.start,
      end: variant.media_range.end
    };
  }

  function getOriginalMediaElements() {
    const productWrapper = document.getElementById('product-wrapper');
    if (!productWrapper) return new Map();

    const mediaItems = productWrapper.querySelectorAll('[data-variant-media]');
    const mediaMap = new Map();

    mediaItems.forEach(item => {
      const mediaIndex = parseInt(item.getAttribute('data-media-index'));
      if (!isNaN(mediaIndex) && !mediaMap.has(mediaIndex)) {
        mediaMap.set(mediaIndex, item);
      }
    });

    return mediaMap;
  }

  function filterSlidesByVariant() {
    const variantId = getCurrentVariantId();
    const mediaRange = getVariantMediaRange(variantId);
    const container = viewport?.querySelector('.embla__container');

    if (!container) return;

    const originalMediaElements = getOriginalMediaElements();

    container.innerHTML = '';
    visibleSlides = [];

    const sortedIndices = Array.from(originalMediaElements.keys()).sort((a, b) => a - b);

    sortedIndices.forEach((mediaIndex) => {
      const isInRange = !mediaRange || (mediaIndex >= mediaRange.start && mediaIndex <= mediaRange.end);

      if (!isInRange) {
        return;
      }
      const originalElement = originalMediaElements.get(mediaIndex);
      if (!originalElement) return;

      const mediaWrapper = originalElement.querySelector('.product-media-item-wrapper');
      if (!mediaWrapper) return;

      const clonedMediaWrapper = mediaWrapper.cloneNode(true);

      const originalImg = mediaWrapper.querySelector('img');
      const clonedImg = clonedMediaWrapper.querySelector('img');
      if (originalImg && clonedImg && originalImg.complete) {
        clonedImg.src = originalImg.src;
        clonedImg.srcset = originalImg.srcset || '';
        clonedImg.sizes = originalImg.sizes || '';
      }

      const originalVideo = mediaWrapper.querySelector('video');
      const clonedVideo = clonedMediaWrapper.querySelector('video');
      if (originalVideo && clonedVideo) {
        const originalSource = originalVideo.querySelector('source[src]');
        const clonedSource = clonedVideo.querySelector('source[data-src]') || clonedVideo.querySelector('source');
        if (originalSource && clonedSource) {
          clonedSource.removeAttribute('data-src');
          clonedSource.setAttribute('src', originalSource.getAttribute('src'));
          clonedVideo.load();
        }
        clonedVideo.currentTime = originalVideo.currentTime || 0;
      }

      const magnifyButton = clonedMediaWrapper.querySelector('.product-video-magnify');
      if (magnifyButton) {
        magnifyButton.remove();
      }

      const slide = document.createElement('div');
      slide.className = 'embla__slide flex-none w-full min-w-0';
      slide.setAttribute('data-media-index', mediaIndex);
      slide.setAttribute('data-variant-media-slide', '');

      const slideContent = document.createElement('div');
      slideContent.className = 'relative w-full aspect-square';
      slideContent.appendChild(clonedMediaWrapper);
      slide.appendChild(slideContent);

      container.appendChild(slide);
      visibleSlides.push(slide);
    });
  }

  function getRelativeSlideIndex(absoluteIndex) {
    filterSlidesByVariant();
    return visibleSlides.findIndex(slide => {
      return parseInt(slide.getAttribute('data-media-index')) === absoluteIndex;
    });
  }

  let prevButtonHandler = null;
  let nextButtonHandler = null;

  function attachNavigationHandlers() {
    if (prevButton && prevButtonHandler) {
      prevButton.removeEventListener('click', prevButtonHandler);
    }
    if (nextButton && nextButtonHandler) {
      nextButton.removeEventListener('click', nextButtonHandler);
    }

    if (prevButton) {
      prevButtonHandler = () => {
        if (embla) {
          embla.scrollPrev();
        }
      };
      prevButton.addEventListener('click', prevButtonHandler);
    }

    if (nextButton) {
      nextButtonHandler = () => {
        if (embla) {
          embla.scrollNext();
        }
      };
      nextButton.addEventListener('click', nextButtonHandler);
    }
  }

  function initCarousel(startIndex = 0) {
    if (typeof EmblaCarousel === 'undefined') {
      setTimeout(() => initCarousel(startIndex), 100);
      return;
    }

    if (embla) {
      embla.destroy();
      embla = null;
    }

    if (!viewport) return;

    filterSlidesByVariant();

    const relativeStartIndex = Math.max(0, Math.min(startIndex, Math.max(0, visibleSlides.length - 1)));

    setTimeout(() => {
      embla = EmblaCarousel(viewport, {
        loop: false,
        align: 'center',
        slidesToScroll: 1,
        startIndex: relativeStartIndex
      });

      function updateButtons() {
        if (!embla) return;

        const canScrollPrev = embla.canScrollPrev();
        const canScrollNext = embla.canScrollNext();

        if (prevButton) {
          prevButton.disabled = !canScrollPrev;
        }
        if (nextButton) {
          nextButton.disabled = !canScrollNext;
        }
      }

      attachNavigationHandlers();

      embla.on('select', () => {
        updateButtons();
        pauseVideosExceptCurrent();
        initModalVideos();
      });

      updateButtons();
      initModalVideos();
    }, 50);
  }

  function initModalVideos() {
    if (visibleSlides.length === 0) return;

    const currentSlideIndex = embla ? embla.selectedScrollSnap() : 0;
    const currentSlide = visibleSlides[currentSlideIndex];
    if (!currentSlide) return;

    const videoWrapper = currentSlide.querySelector('[data-video-wrapper]');
    if (!videoWrapper) return;

    const video = videoWrapper.querySelector('video');
    if (!video) return;

    video.muted = true;
    video.loop = true;
    video.playsInline = true;

    const lazySource = video.querySelector('source[data-src]');
    if (lazySource) {
      const originalSrc = lazySource.getAttribute('data-src');
      lazySource.removeAttribute('data-src');
      lazySource.setAttribute('src', originalSrc);
      video.load();
    } else {
      const source = video.querySelector('source');
      if (source && source.src) {
        video.load();
      }
    }

    video.addEventListener('play', () => {
      videoWrapper.classList.add('is-playing');
    });

    video.addEventListener('pause', () => {
      videoWrapper.classList.remove('is-playing');
    });

    video.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch((e) => {
          console.error('Error playing video:', e);
        });
      } else {
        video.pause();
      }
    });
  }

  function openModal(mediaIndex) {
    if (!modal) return;

    const absoluteIndex = parseInt(mediaIndex) || 0;

    filterSlidesByVariant();
    currentSlideIndex = getRelativeSlideIndex(absoluteIndex);

    if (currentSlideIndex === -1) {
      currentSlideIndex = 0;
    }

    initCarousel(currentSlideIndex);

    modal.classList.remove('opacity-0', 'invisible', 'pointer-events-none');
    modal.classList.add('opacity-100', 'visible');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
  }

  function pauseAllVideos() {
    const allVideos = modal.querySelectorAll('video');
    allVideos.forEach((video) => {
      if (!video.paused) {
        video.pause();
      }
    });
  }

  function pauseVideosExceptCurrent() {
    if (visibleSlides.length === 0) return;

    const currentSlideIndex = embla ? embla.selectedScrollSnap() : 0;
    visibleSlides.forEach((slide, index) => {
      if (index !== currentSlideIndex) {
        const video = slide.querySelector('video');
        if (video && !video.paused) {
          video.pause();
        }
      }
    });
  }

  function closeModal() {
    if (!modal) return;

    pauseAllVideos();

    modal.classList.add('opacity-0', 'invisible', 'pointer-events-none');
    modal.classList.remove('opacity-100', 'visible');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');

    if (embla) {
      embla.destroy();
      embla = null;
    }
  }

  const mediaItems = document.querySelectorAll('[data-open-media-modal]');
  mediaItems.forEach(item => {
    item.addEventListener('click', (e) => {
      if (e.target.closest('[data-video-play-pause]')) {
        return;
      }

      const mediaIndex = item.getAttribute('data-media-index');
      if (mediaIndex !== null) {
        openModal(mediaIndex);
      }
    });
  });

  closeButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeModal();
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.classList.contains('invisible')) {
      closeModal();
    }
  });

  if (modalOverlay) {
    modalOverlay.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeModal();
    });
  }

  const modalContainer = modal.querySelector('.product-media-modal-container');
  if (modalContainer) {
    modalContainer.addEventListener('click', (e) => {
      if (e.target !== modalContainer) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      closeModal();
    });
  }
});

